import React from 'react';
import _ from 'lodash';

import * as baseUI from '#packages/baseUI';
import * as textControls from '#packages/textControls';

import * as advancedStyleControls from '../utils/controlMap';

export interface AdvancedStyleDynamicControlProps {
  type: string;
  propsToPass?: object;
  paramKey?: string;
  tabsUiMode?: 'labels' | 'tabs';
  getControlWrapper?: (styleParamsPath: [string, string] | string) => any;
}

const AdvancedStyleDynamicControl: React.FC<
  AdvancedStyleDynamicControlProps
> = (props) => {
  const { type, paramKey, propsToPass, tabsUiMode, getControlWrapper } = props;

  const elemToCreate =
    textControls[type as keyof typeof textControls] ||
    advancedStyleControls[type as keyof typeof advancedStyleControls] ||
    baseUI[type as keyof typeof baseUI];
  let Control;

  if (!elemToCreate) {
    Control = React.createElement('div', type);
  } else {
    Control = React.createElement(
      elemToCreate,
      _.merge(
        { automationId: paramKey },
        tabsUiMode,
        propsToPass,
        _.omit(props, 'type'),
      ),
    );
  }

  const { ControlWrapper, controlWrapperProps } =
    getControlWrapper?.(paramKey) || {};

  if (ControlWrapper && controlWrapperProps) {
    return React.createElement(ControlWrapper, controlWrapperProps, Control);
  }
  return Control;
};

AdvancedStyleDynamicControl.displayName = 'advanced-style-ui-control';

export default AdvancedStyleDynamicControl;
